import React from "react";

import { connect } from 'react-redux'; 
import propTypes from 'prop-types';

class PolicyFooter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            policyData: []           
        }
    }
    componentWillMount() {   
        
            if (this.props.policyData) {
                this.setState({
                    policyData: this.props.policyData,
                });
            } 
    }       

    render() {
        return (
            <div className="row mt-60">
                {this.state.policyData.returnSettingsMap &&
                        <div className="col ">
                        {this.state.policyData.returnSettingsMap.fullReturnPolicyText &&
                            <React.Fragment>
                                <hr></hr> 
                                <div dangerouslySetInnerHTML={{ __html: this.state.policyData.returnSettingsMap.fullReturnPolicyText }} />
                                <div className="img-container">
                                   <a href="https://nogin.com" target="_blank">
                                     <img src="/returns/img/NOGIN-PoweredBy.png" alt="Powered by Nogin" width="240px"/>
                                   </a>
                                </div>
                            </React.Fragment>
                        }
                        </div>
                }
            </div>
        );
    }
}

PolicyFooter.propTypes = {
    policyData: propTypes.object.isRequired
};

const mapStateToProps = (state) => ({
    policyData: state.storeSettingData.storeDesign
});

export default connect(mapStateToProps, {})(PolicyFooter); 



// WEBPACK FOOTER //
// ./src/components/Common/PolicyFooter.js